 import React, { useState } from 'react';
import PinchZoomPan from "react-responsive-pinch-zoom-pan";

import { PosterModalContext } from '../../utils/contexts';
import { Container, Modal, Content, LinkButton, Button, ExtraButtonsContainer } from '../../styles/modals/generic-modal';
import Header from './parts/modal-header';

export default function PosterModal(props) {

	const [ zoomEnabled, setZoomEnabled ] = useState(false);

	return(
		<PosterModalContext.Consumer>
			{
				({ isOpen, image, pdfLink, linkText, extraButtons, zoomPan, extraWide, setIsOpen }) => {

          if (isOpen) {
            window.history.pushState(null, null, window.location.pathname);
            window.addEventListener('popstate', (e) => {
              e.preventDefault();
              setIsOpen(false)
            });
          }

					const closeModal = () => {
						setIsOpen(false);
						setZoomEnabled(false);
					}

					const Img = <img alt="" src={isOpen? image : null} />;

					return <Container visible={isOpen} className="bg" onClick={(e) => e.target.classList.contains('bg') && closeModal()}>
						<Modal extraWide={extraWide} >
							<Header onCloseClick={closeModal} />
							<Content className="scrollable">
								{ 
									zoomEnabled
									? <PinchZoomPan position="center" initialScale={0.75} minScale={0.5} maxScale={2} >
										{Img}
									</PinchZoomPan>
									: Img
								}
								{zoomPan && <Button style={{ position: 'absolute', top: '10px', right: '20px', zIndex: '1000' }} onClick={() => setZoomEnabled(zoom => !zoom)} >Zoom { zoomEnabled? 'Out' : 'In' }</Button>}
							</Content>
              { pdfLink &&  <>
                <div style={{ padding: '10px', textAlign: 'center' }} >
                  <LinkButton href={pdfLink} target="_blank" rel="noopener noreferrer" >{ linkText || 'Click for details' }</LinkButton>
                </div>
              </>}
              {
                extraButtons && <>
                  <ExtraButtonsContainer>
                    {
                      extraButtons.map(({text, link}, index) => <>
                        <LinkButton href={link} target="_blank" rel="noopener noreferrer" key={`extra_links_${index}`} >
                          { text || 'Click for details' }
                        </LinkButton>
                      </>)
                    }
                    
                  </ExtraButtonsContainer>
                </>
              }
						</Modal>
					</Container>
        }
			}
		</PosterModalContext.Consumer>
	);

}